"use client";

import { useEffect, useState } from "react";
import mainAPI from "../../../services/main/mainAPI";
import CapacityOverview from "../../shared/CapacityOverview";

type CapacityPercent = {
  skillListeningSpeaking: number | null;
  skillLangNature: number | null;
  skillReading: number | null;
  skillWriting: number | null;
};

function normalizeCapacityPercent(response: unknown): CapacityPercent {
  const rawResponse = response as {
    capacity_percent?: {
      skill_listening_speaking?: unknown;
      skill_lang_nature?: unknown;
      skill_reading?: unknown;
      skill_writing?: unknown;
    };
    capacityPercent?: {
      skillListeningSpeaking?: unknown;
      skillLangNature?: unknown;
      skillReading?: unknown;
      skillWriting?: unknown;
    };
    data?: {
      capacity_percent?: {
        skill_listening_speaking?: unknown;
        skill_lang_nature?: unknown;
        skill_reading?: unknown;
        skill_writing?: unknown;
      };
    };
  };

  const capacityPercent = rawResponse.capacity_percent ?? rawResponse.data?.capacity_percent;
  const camelCaseCapacityPercent = rawResponse.capacityPercent;

  const toNullableNumber = (value: unknown) => {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  return {
    skillListeningSpeaking: toNullableNumber(
      capacityPercent?.skill_listening_speaking ?? camelCaseCapacityPercent?.skillListeningSpeaking,
    ),
    skillLangNature: toNullableNumber(
      capacityPercent?.skill_lang_nature ?? camelCaseCapacityPercent?.skillLangNature,
    ),
    skillReading: toNullableNumber(
      capacityPercent?.skill_reading ?? camelCaseCapacityPercent?.skillReading,
    ),
    skillWriting: toNullableNumber(
      capacityPercent?.skill_writing ?? camelCaseCapacityPercent?.skillWriting,
    ),
  };
}

export default function Capacity() {
  const [capacityPercent, setCapacityPercent] = useState<CapacityPercent>({
    skillListeningSpeaking: null,
    skillLangNature: null,
    skillReading: null,
    skillWriting: null,
  });
  const [isLoading, setIsLoading] = useState(false);

  const loadCapacityAvg = async () => {
    setIsLoading(true);
    const response = await mainAPI.getCapacityAvg();

    if (!response || (response as { status?: string })?.status === "failed") {
      setCapacityPercent({
        skillListeningSpeaking: null,
        skillLangNature: null,
        skillReading: null,
        skillWriting: null,
      });
      setIsLoading(false);
      return;
    }

    setCapacityPercent(normalizeCapacityPercent(response));
    setIsLoading(false);
  };

  useEffect(() => {
    void loadCapacityAvg();
  }, []);

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <h1 className="shrink-0 p-4 pb-2 text-lg font-bold text-[#0092D7]">สมรรถนะเฉลี่ยแต่ละด้าน</h1>

      {isLoading ? (
        <div className="px-4 py-6 text-sm text-[#7a7a7a]">กำลังโหลด...</div>
      ) : (
        <div className="min-h-0 flex-1 px-4 pb-4">
          <CapacityOverview
            capacityPercent={capacityPercent}
            variant="wide"
            className="h-full"
          />
        </div>
      )}
    </div>
  );
}
